import ClientForm from "@app/components/forms/client-form.tsx";
import { PageContainer } from "@app/components/page-container.tsx";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_manager/client/create")({
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageContainer title={"Create Client"}>
            <ClientForm />
        </PageContainer>
    );
}
